<!--
 * @Author: cryi.liu
 * @Date: 2020-05-06 15:10:15
 * @LastEditTime: 2020-06-13 09:52:13
 * @Description: 数据表格
 -->
<template>
  <i-table
    border
    :columns="columns"
    :data="content"
    @on-selection-change="selectionDataChanged" />
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'DataTable',
  props: {
    filterMenu: { type: Object, required: true },
    content: { type: Array, required: true },
  },
  data() {
    return {
      questionTypes: [],
      levels: [],
      columns: [],
      deleteId: '',
    };
  },
  watch: {
    filterMenu: {
      immediate: true,
      handler(menu) {
        this.questionTypes = new Array(menu.questionTypes.length);
        this.levles = new Array(menu.levels.length);

        menu.questionTypes.forEach((type, index) => {
          this.$set(this.questionTypes, index, { label: type, value: type });
        });

        menu.levels.forEach((level, index) => {
          this.$set(this.levels, index, { label: level, value: level });
        });

        this.setColumns();
      },
    },
  },
  methods: {
    ...mapActions({
      setDeleteIds: 'libraryStore/invokeSetDeleteIds',
      setQuestionTypesFilter: 'libraryStore/invokeSetQuestionTypesFilter',
      setLevelsFilter: 'libraryStore/invokeSetLevelsFilter',
    }),
    /**
     * 设置表头
     */
    setColumns() {
      this.columns = [
        {
          type: 'selection',
          width: 60,
          align: 'center',
        },
        {
          title: '题型',
          key: 'questionType',
          align: 'center',
          filters: this.questionTypes,
          filterRemote(values) {
            this.setQuestionTypesFilter({ questionTypes: values });

            this.$emit('reset-index-repull-list');
          },
          render: (h, params) => h('div', [
            h('span', params.row.questionType),
          ]),
        },
        {
          title: '题目ID',
          key: 'dateSequence',
          align: 'center',
        },
        {
          title: '题目',
          key: 'content',
          align: 'center',
        },
        {
          title: '难易度',
          key: 'level',
          align: 'center',
          filters: this.levels,
          filterRemote(values) {
            this.setLevelsFilter({ levels: values });

            this.$emit('reset-index-repull-list');
          },
        },
        {
          title: '创建人',
          key: 'createUser',
          align: 'center',
        },
        {
          title: '创建时间',
          key: 'createDate',
          align: 'center',
        },
        {
          title: '操作',
          key: 'action',
          width: 150,
          align: 'center',
          render: (h, params) => h('div', [
            h('a', {
              style: {
                marginRight: '5px',
              },
              on: {
                click: this.routeToQuestionDetail(params.row),
              },
            }, '查看'),
            h('a', {
              on: {
                click: this.deleteQuestionHandler(params.row),
              },
            }, '删除'),
          ]),
        },
      ];
    },
    /**
     * 表格多选数据发生变化处理函数
     */
    selectionDataChanged(selection) {
      const deleteIds = [];

      selection.forEach(({ id }) => {
        deleteIds.push(id);
      });

      this.setDeleteIds({
        deleteIds,
      });
    },
    /**
     * 删除题库题目处理函数
     */
    deleteQuestionHandler({ id }) {
      return () => {
        const flag = window.confirm('确认删除?');

        if (flag) {
          this.deleteId = id;

          this.requestDeleteQuestionAndRepull();
        }
      };
    },
    /**
     * 请求删除题库题目并重新请求列表
     */
    requestDeleteQuestionAndRepull() {
      this.requestDeleteQuestion()
        .then(() => {
          alert('删除成功');
          this.$emit('repull-list');
        })
        .catch((result) => {
          alert(result.msg);
        });
    },
    /**
     * 请求删除题库题目
     */
    requestDeleteQuestion() {
      return new Promise(async (resolve, reject) => {
        const params = {
          libraryIds: this.deleteId,
        };

        const result = await this.$http.examcenter.libraryDeleteQuestion(params);

        if (result.code === '200') {
          resolve(result);
        } else {
          reject(result);
        }
      });
    },
    /**
     * 跳转到题目详情页
     */
    routeToQuestionDetail({ id }) {
      return () => {
        if (process.env.NODE_ENV === 'development') {
          window.open(`#/question/detail/${id}`, '_blank');
        } else {
          window.open(`/examcentersite/#/question/detail/${id}`, '_blank');
        }
      };
    },
  },
};
</script>
